export default "__VITE_ASSET__K1Z3nboX__"